<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div :class="`${$style.pageWrapper}`">
      <img :class="$style.pageBack" :src="backgroundImage" />
      <div :class="$style.pageContent">
        <PlaceContent
          title="在玩游戏会场"
          :dataSource="playGames"
          @click-item="onSkipDetail"
        >
          <template v-slot:empty>
            <p>暂无在玩游戏～</p>
            <p>请查看下方更多游戏会场，</p>
            <p>选择自己喜欢的游戏下载参与活动吧！</p>
          </template>
        </PlaceContent>
        <PlaceContent
          title="更多游戏会场"
          :dataSource="moreGames"
          @click-item="onSkipDetail"
        >
          <template v-slot:empty>
            <p>暂无更多游戏～</p>
          </template>
        </PlaceContent>
      </div>
      <!-- 弹窗 -->
      <ActivityDialog
        title="不满足活动条件"
        :visible="dialogVisible"
        :hideCancel="true"
        sureText="下载游戏"
        @click-sure="onHandleGame"
        @click-cancel="dialogVisible = false"
      >
        <template v-slot:main>
          <p style="text-align: center">
            账号没有游戏记录，请下载并用此账号进入游戏后返回会场进入活动
          </p>
        </template>
      </ActivityDialog>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1, CDN_URL } from "@/config";
import {
  onGoBack,
  setPageTitle,
  getUserInfo,
  toLogin,
  signInEventTrack,
  jumpToNative
} from "@/bridge/AppJsBridge";
import { getBtWeekSignInPlaceListApi, sendPoint } from "@/apis/btBoxActivity";
import { PullRefresh } from "vant";
import PlaceContent from "@/components/btBox/PlaceContent";
import ActivityDialog from "@/components/btBox/ActivityDialog";
import { getCookie } from "@/libs/utils";

export default {
  name: "",
  components: {
    PullRefresh,
    PlaceContent,
    ActivityDialog,
  },
  data() {
    return {
      cdnLink: CDN_URL_1,
      pageTitle: "",
      userInfo: "",
      isLoading: false,
      moreGames: [],
      playGames: [],
      dialogVisible: false,
      CDN_URL: CDN_URL,
      gameInfo: null,
      cookie: null,
      backgroundImage: "",
    };
  },
  computed: {},

  created() {
    // 页面初始化
    inithandler();
    this.initPageData();
  },
  activated() {
    
  },
  mounted() {},
  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      sendPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 获取缓存等携带的用户信息数据
    async initPageData() {
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      this.getAppToken();
    },
    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getActPlaceData();
      } else {
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            localStorage.setItem("token", Info.token);
          }
          this.getActPlaceData();
        });
      }
    },
    // 获取会场信息
    getActPlaceData() {
      getBtWeekSignInPlaceListApi()
        .then((res) => {
          const { data } = res;
          this.playGames = data.playGames;
          this.moreGames = data.moreGames;
          this.pageTitle = data.activeName;
          setPageTitle(data.activeName);
          this.backgroundImage = data.backgroundImage;
          this.eventTrack({
            event: "week_sign_summary_page",
            event_field: JSON.stringify({ activity_name: data.activeName }),
          });
        })
        .catch((err) => {
          if (err.response && err.response.data.code == 401) {
            toLogin("/loginKey/LoginByKeyPhoneActivity");
          }
        });
    },

    // 跳转游戏活动页面
    async onSkipDetail(data) {
      const { placeId, isMore, gameId, appName } = data;
      this.gameInfo = data;
      this.eventTrack({
        event: "week_entry_branch",
        event_field: JSON.stringify({ is_play: isMore,activity_name: this.pageTitle  }),
        appkey: gameId,
        appName: appName,
      });
      // if (isMore) {
      //   this.dialogVisible = true;
      //   this.eventTrack({
      //     event: "week_entry_failure_pop",
      //     event_field: JSON.stringify({ activity_name: this.pageTitle }),
      //     appkey: this.gameInfo.gameId,
      //     appName: this.gameInfo.appName,
      //   });
      //   return;
      // }
      this.$router.push({
        name: `box.btWeekSignInAct`,
        query: { placeId: placeId,isPlay: isMore},
      });
    },

    // 跳转游戏
    onHandleGame() {
      this.eventTrack({
        event: "week_pop_download_game",
        event_field: JSON.stringify({ activity_name: this.pageTitle }),
        appkey: this.gameInfo.gameId,
        appName: this.gameInfo.appName,
      });
      this.dialogVisible = false;
      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams: this.gameInfo.gameId,
        fromPageType: 18,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 关闭页面
    closePage() {
      onGoBack();
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageWrapper {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #ffc34a;
  position: relative;
  .pageBack {
    width: 100%;
    height: 100vh;
    z-index: 1;
  }
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
    .download {
      top: 0px;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }

  .pageContent {
    margin: 0 auto;
    top: 39.5%;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 2;
  }
}
</style>
